import type { CurrentCampaign } from '~/types/campaigns'
import type { CurrentUser } from '~/types/users'

import { fetchIgnoreErrors, redirectRoute } from './fetchRoute'

// Switching - returns null if not authorized
export const getCurrentUser = async (): Promise<CurrentUser> => {
  const data: CurrentUser = await fetchIgnoreErrors('/api/current-user')
  return data
}

// Switching - returns null if no campaign id
// Returns campaign if found.
export const getCurrentCampaign = async (campaignId) => {
  let campaign = null
  if (campaignId) {
    const campaignData = await fetchIgnoreErrors('/api/campaigns/' + campaignId)
    if (campaignData) {
      campaign = campaignData as CurrentCampaign
    }
  }

  return { campaign }
}

export const getUserAndCampaign = async (campaignId?: number) => {
  const [currentUser, { campaign }] = await Promise.all([
    getCurrentUser(),
    getCurrentCampaign(campaignId)
  ])

  // don't proceed, redirect to sign-in
  if (!currentUser) return { currentUser: null, campaign: null }

  return {
    campaign,
    currentUser
  }
}

export const authorizePageAccess = async (ctx, campaignId?: number) => {
  let { currentUser, campaign } = await getUserAndCampaign(campaignId)

  // don't proceed, redirect to sign-in
  if (!currentUser || currentUser.archived_at) {
    // No user, redirect to sign in.
    redirectRoute(ctx?.res, '/sign-in')
    return { currentUser: null, campaign: null }
  }

  return {
    campaign,
    currentUser
  }
}

export const authorizePageAccessAdmin = async (ctx) => {
  const currentUser = await getCurrentUser()
  if (!currentUser) return { currentUser: null }

  if (!currentUser.isAdmin) {
    redirectRoute(ctx?.res, '/campaigns')
    return { currentUser: null }
  }

  return {
    currentUser
  }
}
